/* @flow */
import { omit } from 'ramda';
import { Dropzone, type DropzoneProps } from './Dropzone.js';
import { formatFilesize } from 'trustar/utils/utils';

import classnames from 'classnames/bind';
import s from './PreviewDropzone.styl';
const cx = classnames.bind(s);
import {Button, IconButton, IconButtonPure} from 'trustar-2.0/components/Button';
import {Icon, IconLookup} from 'trustar-2.0/components';

import React from 'react';

type PropsShape = DropzoneProps & {
  existingImageUrl: ?string,
  imageFile: File,
  setFile: Function,
  clearExistingImageUrl: Function,
  onError: Function,
};

type StateShape = {
  imagePreviewUrl: ?ArrayBuffer | ?string,
};

export class PreviewDropzone extends React.Component {

  props: PropsShape
  state: StateShape = {
    imagePreviewUrl: null,
  }

  componentDidMount() {
    // if a file is passed initially, set it
    if (this.props.imageFile) {
      this.setPreview(this.props.imageFile);
    }
  }

  storeImage = ((files: File[]) => {
    const file = files[0];
    this.props.setFile(file);
    this.setPreview(file);
  });

  removeImage = () => {
    this.props.setFile(null);
  }

  imagePreviewUrl = () => {
    const existing = this.props.existingImageUrl;
    if (existing) {
      return existing;
    } else {
      return this.state.imagePreviewUrl;
    }
  }

  setPreview = (file: File) => {
    // used to render an image preview upon file drop
    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({
        imagePreviewUrl: reader.result
      });
    };
    reader.readAsDataURL(file);
  }

  // handles icon uploading errors
  handleUploadRejected = ((files: File[]) => {
    this.props.onError('Make sure the image is the appropriate format and size.');
  });

  // Deletes dropped file in the Dropzone component
  onRemoveContent = () => {
    if (this.props.imageFile) {
      this.removeImage();
    } else {
      this.props.clearExistingImageUrl();
      this.setState({
        imagePreviewUrl: null,
      });
    }
  }

  render() {

    const imagePreviewUrl = this.imagePreviewUrl();

    if (!imagePreviewUrl) {
      return (
        <Dropzone
          {...omit(['imageFile', 'existingImageUrl', 'setFile', 'clearExistingImageUrl', 'onError'], this.props)}
          onDropRejected={this.handleUploadRejected}
          onDropAccepted={this.storeImage}
        />
      );
    } else {

      const file = this.props.imageFile;
      const filename = file
        ? file.name
        : 'Current Icon';

      return (
        <div className={cx('imgUrl')}>
          <img src={imagePreviewUrl} />
          <IconButton icon={IconLookup.TRASH2} transparent size={'small'} className={cx('remove')} onClick={this.onRemoveContent} type='button'>
            <strong>{filename}</strong>
            { file &&
              <span style={{marginLeft: 10}}>
                {formatFilesize(file.size)}
              </span>
            }
          </IconButton>
        </div>
      );
    }
  }

}




// WEBPACK FOOTER //
// ./web_modules/trustar/components/PreviewDropzone.js